import axios from "@/plugins/axios";

const RESOURCE = "economic-groups";

/**
 * Obtiene el listado paginado (para la tabla principal)
 * @param {Object} params - Query params (page, sort, filter)
 */
export const fetchEconomicGroups = (params = {}) => {
  return axios.get(RESOURCE, { params });
};

/**
 * Obtiene el listado completo para selects (Ruta: economic-groups/all)
 */
export const fetchEconomicGroupsList = () => {
  return axios.get("economic-groups/all");
};

/**
 * Obtiene un grupo por ID
 * @param {Number|String} id 
 */
export const getEconomicGroup = (id) => {
  return axios.get(`${RESOURCE}/${id}`);
};

/**
 * Crea un nuevo grupo
 * @param {Object} data 
 */
export const createEconomicGroup = (data) => {
  return axios.post(RESOURCE, data);
};

/**
 * Actualiza un grupo existente
 * @param {Number|String} id 
 * @param {Object} data 
 */
export const updateEconomicGroup = (id, data) => {
  return axios.put(`${RESOURCE}/${id}`, data);
};

/**
 * Elimina un grupo
 * @param {Number|String} id 
 */
export const destroyEconomicGroup = (id) => {
  return axios.delete(`${RESOURCE}/${id}`);
};

/**
 * Asocia una concesionaria a un grupo
 */
export const associateConcessionaire = (groupId, concessionaireId) => {
  return axios.post(`${RESOURCE}/${groupId}/associate-concessionaire`, {
    concessionaire_id: concessionaireId
  });
};

/**
 * Desvincula una concesionaria de su grupo actual
 */
export const unlinkConcessionaire = (concessionaireId) => {
  return axios.post(`${RESOURCE}/unlink-concessionaire`, {
    concessionaire_id: concessionaireId
  });
};